import storage from './storage';

export default function() {
  const { languages, language, userLanguage } = navigator;
  const auth = storage.getItem('auth');
  const previousLang = storage.getItem('language');
  const locale = previousLang || (languages && languages[0]) || language || userLanguage;
  let lang = locale.toLowerCase().split(/[_-]+/)[0];

  // TODO: Somehow get purchase language and use it if `!lang`

  if (auth && auth.languageCode) {
    lang = auth.languageCode;
  }

  return lang;
}



// WEBPACK FOOTER //
// ./src/lib/detect-language.js